module.exports = __webpack_public_path__ + "static/media/girl.3e75503d.png";